export default __webpack_public_path__ + "static/media/twitter-logo.20301630.png";